import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CirclePerson from './icon-circle-person.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CirclePerson {...validProps} />;
}
SvgComponent.iconName = 'circlePerson';

export const CirclePersonIcon = svgIconWrapper(SvgComponent);
